import { ValidateTmpToken, ValidateToken } from '../requests/AuthRequests'

const normalizeRespIsValid = (resp) => {
  if (resp === true) return true
  if (resp && typeof resp === 'object' && 'data' in resp) return resp.data === true
  return false
}

export const validateToken = async () => {
  const authToken = localStorage.getItem('authToken')
  const { success, data } = await ValidateToken({ token: authToken })

  if (success) return data

  return false
}

export const validateTemporaryToken = async (candidate, signal) => {
  if (!candidate) return false
  
  try {
    const resp = await ValidateTmpToken({ token: candidate }, signal)
    return normalizeRespIsValid(resp)
  } catch (err) {
    return false
  }
}
